module.exports = __webpack_public_path__ + "static/img/55.82d08da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home/55.jpg
// module id = UGTU
// module chunks = 29